import {
    GET_LIST_CUSTOMER_CONSULTANT
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    customerConsultantList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_CONSULTANT: {
            return {
                ...state,
                customerConsultantList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
